"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledSurveySelect=exports.StyledSurveyInfoText=exports.StyledSurveyPageSectionContainer=void 0;const antd_1=require("antd"),styled_components_1=__importDefault(require("styled-components"));exports.StyledSurveyPageSectionContainer=styled_components_1.default.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 10px;
`,exports.StyledSurveyInfoText=styled_components_1.default.div`
  font-family: Poppins;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 60px;
  line-height: 28px;
`,exports.StyledSurveySelect=(0,styled_components_1.default)(antd_1.Select)`
  width: 100%;
  height: 56px;
  border-radius: 4px;
  font-family: Poppins;
  font-size: 16px;
  .ant-select-selection-placeholder{
    color: black;
  }
  .ant-select-arrow{
    color: black;
  } 
`;